import React from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';

//Estilos
import './Login.css';
import './LoginMediaQueries.css';
import logo from '../../assets/imgs/logo_inavi.png';

function Login({ functions }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        onSubmit,
    } = functions;

    return (
        <div className="form-background" onSubmit={handleSubmit(onSubmit)}>
            <form className="form-login">
                <img src={logo} className="login-logo" />
                <label className="label-login">
                    <span>Usuario: </span>
                    <input
                        className="login-input"
                        type="text"
                        {...register('usuario', {
                            required: 'Debe ingresar un usuario',
                        })}
                        onKeyPress={(e) => {
                            if (e.target.value.length > 20) {
                                e.preventDefault();
                            }
                        }}
                    />
                    {errors.usuario && (
                        <small className="form__error">
                            {errors.usuario.message}
                        </small>
                    )}
                </label>
                <label className="label-login">
                    <span>Clave: </span>
                    <input
                        className="login-input"
                        type="password"
                        autoComplete="off"
                        {...register('clave', {
                            required: 'Debe ingresar una clave',
                        })}
                        onKeyPress={(e) => {
                            if (e.target.value.length > 20) {
                                e.preventDefault();
                            }
                        }}
                    />
                    {errors.clave && (
                        <small className="form__error">
                            {errors.clave.message}
                        </small>
                    )}
                </label>
                <button className="btn btn-primary btn-login" type="submit">
                    Inicio
                </button>
                <p>
                    ¿No tiene cuenta?{' '}
                    <Link to={RoutesApp.Signup}>Regístrese</Link>
                </p>

                <Link to={RoutesApp.RequestNewPassword}>¿Olvidó su clave?</Link>
                <Link to={RoutesApp.RecoverUserName}>
                    ¿Olvidó su nombre de usuario?
                </Link>
            </form>
        </div>
    );
}

export default Login;
